import ApiClient, { handleApiCall } from "../api";

/** Order list reads — no global loader; list page uses inline skeleton. */
export const getOrderDetails = (page: number | string, storeId: number | string) =>
  ApiClient.get(`orders?page=${page}&limit=10&store_id=${storeId}`);

export const viewOrderDetails = (id: any, isLoading?: boolean) =>
  handleApiCall("get", `orders/${id}`, null, {}, isLoading);

export const createOrderDetails = (payload: any) =>
  handleApiCall("get", "orders", payload);

export const getCancelReasons = () =>
  handleApiCall("get", "order-cancel-reasons");

export const createCancelOrder = (id: number, payload: any) =>
  handleApiCall("patch", `orders/${id}/cancel`, payload);

export const createCartDetails = (payload: any) =>
  handleApiCall("post", `orders/cart`, payload);

export const createCancelInvoice = (payload: any) =>
  handleApiCall("post", `/orders/create-invoice`, payload);

export const createBilledInvoice = (payload: any) =>
  handleApiCall("post", `/orders/create-invoice`, payload);

export const setPreparationTime = (payload: any) =>
  handleApiCall("post", `orders/preparation-time`, payload);

// Create Shipment
export const createCalculateShipment = (payload: any) =>
  handleApiCall("post", "invoices/calculate-rate", payload);

export const createShipment = (postPayload: any) =>
  handleApiCall("post", `/invoices/create-shipment`, postPayload);

// Download Shipment Packed
export const packingLabel = (id: any, config = {}) =>
  handleApiCall("get", `/invoices/${id}/packing-label`, config);

// New: status-specific services for tabs
export const getNewOrders = (page: any, storeId: any, status?: string, isLoading: boolean = true) =>
  handleApiCall(
    "get",
    `/orders?page=${page}&limit=10&store_id=${storeId}&search=pending`,
    null,
    {},
    isLoading
  );

export const getPreparingOrders = (page: any, storeId: any, status?: string, isLoading: boolean = true) =>
  handleApiCall(
    "get",
    `/invoices?page=${page}&limit=10&store_id=${storeId}&status=billed&status=agent-assigned&status=agent-arrived-restaurant&isPacked=false`,
    null,
    {},
    isLoading
  );

export const getReadyOrders = (page: any, storeId: any, status?: string, isLoading: boolean = true) =>
  handleApiCall(
    "get",
    `/invoices?page=${page}&limit=10&store_id=${storeId}&status=packed&status=picked&status=out-for-delivery&status=agent-assigned&status=agent-arrived-restaurant&isPacked=true`,
    null,
    {},
    isLoading
  );

export const getDeliveredOrders = (page: any, storeId: any, status?: string) =>
  handleApiCall(
    "get",
    `/invoices?page=${page}&limit=10&store_id=${storeId}&search=delivered`
  );

export const getCompletedOrders = (
  page: any,
  storeId: any,
  status?: string,
  fromDate?: string,
  toDate?: string
) => {
  let url = `/orders?page=${page}&limit=10&store_id=${storeId}`;

  if (fromDate && toDate) {
    url += `&from_date=${fromDate}&to_date=${toDate}`;
  } 
  
  if (status === "all") {
    url += `&status=completed&status=cancelled`;
  } else {
    url += `&search=${status}`;
  }

  return handleApiCall("get", url);
};

// export const getFiltersOrders = (page: any, storeId: any, status?: string, search?: string) =>
// 	handleApiCall("get", `/orders?page=${page}&limit=10&store_id=${storeId}&search=${search}`);

export const getInvoiceDownload = (id: number) =>
  handleApiCall("get", `/invoices/pdf/${id}/download`, {
    responseType: "blob",
  });

// Download invoice PDF
export const downloadInvoicePdf = (invoiceId: number) =>
  handleApiCall("get", `/invoices/pdf/${invoiceId}/download`, {
    responseType: "blob",
  });

// Exotel API - Initiate call
export const initiateExotelCall = (payload: {
  order_id: string;
  from: string;
  to: string;
}) => handleApiCall("post", "/exotel", payload);

// Payment Refund
export const paymentRefund = (invoiceId: number, payload: any) => {
  return handleApiCall("patch", `/invoices/${invoiceId}/payment-refund`, payload) 
};